
@if (isLoading) {
  <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
}
<div class="projectable-form-wrapper frontdoor-form"
  (keyup.escape)="closeModal(false)"
    (keyup.enter)="save($event)"
  >
  <lib-form-header
    [data]="formData"
    [title]="isExistingEntity ? 'View Client Certificate: ' : 'Create New Client Certificate'"
    [moreActions]="moreActions"
    (actionRequested)="headerActionRequested($event)"
    [(formView)]="formView"
  ></lib-form-header>
  <div class="integration-form-container projectable-form-container">
    @if (formView === 'simple') {
      <div class="form-group-row">
        <div class="form-group-column two-fifths">
          <lib-form-field-container [title]="'Client Certificate Details'">
            <div class="stacked-fields">
              <div class="field-row frontdoor-error-stack" [class.frontdoor-error-field]="nameError">
                <div class="field-label">
                  <span class="frontdoor-inline-error-group">
                    Client Certificate Name
                    <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="nameError">
                      {{ nameErrorMessage || 'Must not be empty' }}
                    </span>
                  </span>
                </div>
                <input
                  placeholder="Name your client certificate"
                  [(ngModel)]="formData.name"
                />
              </div>

              <div class="field-row frontdoor-error-stack" [class.frontdoor-error-field]="valueError">
                <div class="field-label">
                  <span class="frontdoor-inline-error-group">
                    Certificate Value
                    <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="valueError">
                      {{ valueMessage || 'Certificate value is required' }}
                    </span>
                  </span>
                </div>
                <textarea
                  style="padding-top: 20px;"
                  [(ngModel)]="formData.value"
                  placeholder="This must be in the OpenSSL PEM format. Example: -----BEGIN CERTIFICATE REQUEST----- ... -----END CERTIFICATE REQUEST-----"
                >
                </textarea>
              </div>
            </div>
          </lib-form-field-container>
        </div>
      </div>
    }
    @if (formView === 'raw') {
      <div class="form-group-column">
        @if (formData) {
          <lib-json-view [(data)]="formData"></lib-json-view>
        }
      </div>
    }

  </div>
</div>